import { Component, OnInit } from '@angular/core';
import { UserService } from '../../core/services/v2/user.service';
import { PatientService } from '../../core/services/v2/patient.service';
import { UserActivity } from '../models/user-activity.model';
import { WindowLoaderService } from '../../shared/components/window-loader/window-loader.service';
import { CommonService } from '../../core/services/v2/common.service';
import { Patient } from '../../core/models/patient/patient';
import { MatDialog, PageEvent } from '@angular/material';
import { DatePipe } from '@angular/common';
import { UserAddDialogComponent } from '../../shared/components/user-add-dialog/user-add-dialog.component';

@Component({
  selector: 'app-user-activity',
  templateUrl: './user-activity.component.html',
  styleUrls: ['./user-activity.component.scss'],
  providers: [DatePipe]
})
export class UserActivityComponent implements OnInit {
  pageSize: number = 10;
  page: number = 1;
  pageLength: number = 10;
  userActivity: any;
  puserid: string = "";
  datetype: string = "";
  lastlogindate: string = "";
  lastactivitydate: string = "";
  pstartdate: Date;
  penddate: Date;
  patients: UserActivity[] = [];
  userresult: any;
  constructor(private loaderService: WindowLoaderService, private userService: UserService, public datepipe: DatePipe, public dialog: MatDialog) {
    this.datetype = 'Signupdate';
  }

  ngOnInit() {
    this.getPatientDetails();
  }
  async getPatientDetails() {

    var v1 = this.datetype;
    await this.userService.getUserActivity().subscribe(
      (patients) => {
        this.patients = patients;
        this.userresult = this.patients
        console.log(this.patients);
      },
      (error) => { console.error(error); }
    );
  }


  changeIndex(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.page = event.pageIndex + 1;

  }
  searchResult() {

    var v1 = this.datetype;
    const sdate = this.pstartdate != undefined ? new Date(this.pstartdate) : "";
    const edate = this.penddate != undefined ? new Date(this.penddate) : "";
    this.userresult = "";

    this.userresult = this.patients.filter((item) => (this.puserid != "" ? (item.userID == this.puserid) : "" == "" &&

      /* (this.datetype != "" ? item.signupdate == this.datetype.trim() : "" == "") &&*/
      (this.datetype != "" ? (this.datetype == "Signupdate" ? ((this.pstartdate != null && this.penddate != null) ? (new Date(item.signupdate) >= new Date(this.pstartdate) &&
        new Date(item.signupdate) <= new Date(this.penddate)) : "" == "") :
        ((this.pstartdate != null && this.penddate != null) ? (new Date(item.lastlogindate) >= new Date(this.pstartdate) &&
          new Date(item.lastlogindate) <= new Date(this.penddate)) : "" == "")) :
        (((this.pstartdate != null && this.penddate != null) ? (new Date(item.lastlogindate) >= new Date(this.pstartdate) &&
          new Date(item.lastlogindate) <= new Date(this.penddate)) : "" == "") ||
          ((this.pstartdate != null && this.penddate != null) ? (new Date(item.signupdate) >= new Date(this.pstartdate) &&
            new Date(item.signupdate) <= new Date(this.penddate)) : "" == "")))
      //(((this.pstartdate != null && this.penddate != null) ? (new Date(item.lastlogindate) >= new Date(this.pstartdate) &&
      //  new Date(item.lastlogindate) <= new Date(this.penddate)) : "" == "") ||
      //((this.pstartdate != null && this.penddate != null) ? (new Date(item.signupdate) >= new Date(this.pstartdate) &&
      //new Date(item.signupdate) <= new Date(this.penddate)) : "" == ""))
    ));
    this.page = 1;
  }

  clearFilter() {
    this.puserid = "";
    this.datetype = "";
    this.pstartdate = null;
    this.penddate = null;
    this.lastlogindate = "";
    this.lastactivitydate = "";
    this.userresult = this.patients;
    this.page = 1;
  }

  addNewUser() {
    this.dialog.open(UserAddDialogComponent, {
      width: '600px'
    });

  }
}
